export const resetState = ({ commit }) => {
  commit("RESET_STATE");
};
